<template>
	<div class="nav notification-bell" :class="isOpen && 'is-open'">
		<button
			class="notification-bell__btn"
			data-id="header-notifications-bell"
			@click="notifyClick"
		>
			<div
				class="notification-bell__badge-count"
				data-id="total-count-badge"
			>
				<span>{{ displayCounter }}</span>
			</div>
			<i class="icon icon-notification-2"></i>
		</button>
	</div>
</template>

<script>
export default {
	name: 'VueNotificationBell',
	props: {
		counter: {
			type: Number,
			default: 0,
			require: true
		},
		displayLimit: {
			type: Number,
			default: 99
		},
		hasDisplayLimit: {
			type: Boolean,
			default: false
		},
		isOpen: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		displayCounter() {
			let text = this.counter;

			if (this.hasDisplayLimit && this.counter > this.displayLimit) {
				text = this.displayLimit + '+';
			}

			return text;
		}
	},
	methods: {
		notifyClick() {
			this.$emit('bellClicked');
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * [Description]
    *
    * Notification Btn
    * Can use SCSS variables = TRUE
*/
.notification-bell {
	@include mq($from: md-l) {
		&:hover {
			background: var(--menu-list-bg-hover);
			color: var(--menu-list-fg-hover);
		}
	}

	&.is-open {
		@include mq($until: sm-l) {
			.notification-bell__btn .icon {
				color: var(--bg-0);
			}
		}
	}

	&__btn {
		position: relative;
		@include clear-btn-styles;
		width: 42px;
		height: 100%;
		font-size: 20px;
		padding: 0 $padding-sm;

		.icon {
			color: var(--black);
		}

		@include header-focus-styles;
	}

	&__badge-count {
		position: absolute;
		top: 1px;
		left: 20px;
		cursor: pointer;
		border: 2px solid var(--bg-1);
		@include small-badge('negative');
	}
}
</style>
